import { cn as e } from "../cn.js";
import { cardBody as t, cardDescription as n, cardFooter as r, cardHeader as i, cardImage as a, cardRoot as o, cardTitle as s } from "./styles.js";
import { CardPresets as c, EmployeeCard as l, SectionCard as u } from "./presets.js";
import * as d from "react";
import { jsx as f } from "react/jsx-runtime";
// src/design/card/index.tsx
var p = d.forwardRef(({ children: t, className: n, variant: r = "outlined", size: i = "md", padding: a, fullWidth: s = !1, ...c }, l) => /* @__PURE__ */ f("div", {
	ref: l,
	className: e(o({
		variant: r,
		size: a === void 0 ? i : a
	}), s && "w-full", n),
	...c,
	children: t
}));
p.displayName = "Card.Root";
var m = d.forwardRef(({ children: t, className: n, spacing: r = "md", bordered: a = !1, ...o }, s) => /* @__PURE__ */ f("div", {
	ref: s,
	className: e(i({
		spacing: r,
		bordered: a
	}), n),
	...o,
	children: t
}));
m.displayName = "Card.Header";
var h = d.forwardRef(({ children: t, className: n, size: r = "md", as: i = "h3", ...a }, o) => /* @__PURE__ */ f(i, {
	ref: o,
	className: e(s({ size: r }), n),
	...a,
	children: t
}));
h.displayName = "Card.Title";
var g = d.forwardRef(({ children: t, className: r, size: i = "md", ...a }, o) => /* @__PURE__ */ f("p", {
	ref: o,
	className: e(n({ size: i }), r),
	...a,
	children: t
}));
g.displayName = "Card.Description";
var _ = d.forwardRef(({ children: n, className: r, spacing: i = "md", ...a }, o) => /* @__PURE__ */ f("div", {
	ref: o,
	className: e(t({ spacing: i }), r),
	...a,
	children: n
}));
_.displayName = "Card.Body";
var v = d.forwardRef(({ children: t, className: n, spacing: i = "md", bordered: a = !1, justify: o = "end", ...s }, c) => /* @__PURE__ */ f("div", {
	ref: c,
	className: e(r({
		spacing: i,
		bordered: a,
		justify: o
	}), n),
	...s,
	children: t
}));
v.displayName = "Card.Footer";
var y = d.forwardRef(({ className: t, src: n, alt: r, position: i = "top", aspectRatio: o = "auto", ...s }, c) => /* @__PURE__ */ f("img", {
	ref: c,
	src: n,
	alt: r,
	className: e(a({
		position: i,
		aspectRatio: o
	}), t),
	...s
}));
y.displayName = "Card.Image";
var b = d.forwardRef(({ children: e, ...t }, n) => /* @__PURE__ */ f(p, {
	ref: n,
	...t,
	children: e
}));
b.displayName = "Card", b.Root = p, b.Header = m, b.Title = h, b.Description = g, b.Body = _, b.Footer = v, b.Image = y;
export { b as Card, c as CardPresets, l as EmployeeCard, u as SectionCard };

//# sourceMappingURL=index.js.map